import depo from './depo';
import { sistemKonsol } from './sistemKonsol';
import { getAktifLisanslar } from './lisans';
import AuthService from './auth.service';
import { yerelUygulama } from './platform';
import { PANEL_KOK } from './apiAdres';

// IZ-P (SaglayiciKonsolu/ISTATISTIK-VE-IZLEME-PLANI.md K1/K6/V14): panel Google Analytics 4.
// - VUE_APP_GA_ID boşsa HİÇBİR şey yüklenmez, hiçbir istek atılmaz (tüm fonksiyonlar no-op).
// - Panelde Consent Mode / çerez şeridi yok (K6); aydınlatma satırı CerezFooter'da.
// - KİMLİK ASLA GÖNDERİLMEZ: user_id, şirket/kullanıcı kimliği, rowid, e-posta, ad yok.
//   page_view yolu query'siz; parametreli rotalarda (ör. /sistem/sirketler/:SirketNo) gerçek yol
//   yerine rota ŞABLONU gönderilir — URL'deki rowid GA'ya gitmesin.
// - Kullanıcı özellikleri yalnız: hesap_turu (kiraci | saglayici | demo), paket (aktif lisans kodları),
//   istemci (web | uygulama — MOB M1-2 kararı: uygulama trafiği raporda ayrılır; GA4'ün kendi
//   'platform' boyutuyla karışmasın diye bu ad).

const GA_ID = (process.env.VUE_APP_GA_ID || '').trim();
const AKTIF = !!GA_ID && typeof window !== 'undefined';
const ISTEMCI = yerelUygulama ? 'uygulama' : 'web';
let yuklendi = false;
let ozellikToken = null; // kullanıcı özelliklerinin ayarlandığı oturum (token değişince yeniden)

function gtag() {
  // gtag.js'in beklediği biçim: arguments nesnesi dataLayer'a itilir.
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function yukle() {
  if (!AKTIF || yuklendi) return;
  yuklendi = true;
  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, {
      send_page_view: false, // SPA: page_view router.afterEach'ten elle
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
    gtag('set', 'user_properties', { istemci: ISTEMCI });
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_ID);
    document.head.appendChild(s);
  } catch (e) { /* ölçüm uygulamayı asla bozmaz */ }
}

// Gönderilecek yol: parametreli rotada şablon (":SirketNo"), değilse gerçek yol; query/hash yok.
function guvenliYol(to) {
  try {
    const params = to && to.params ? Object.keys(to.params) : [];
    const son = to && to.matched && to.matched.length ? to.matched[to.matched.length - 1] : null;
    if (params.length && son && son.path) return son.path;
    return (to && to.path) || '/';
  } catch (e) {
    return '/';
  }
}

export function sayfa(to) {
  if (!AKTIF) return;
  yukle();
  try {
    const yol = guvenliYol(to);
    gtag('event', 'page_view', {
      page_path: yol,
      // otomatik page_location query taşımasın; uygulamada origin https://localhost → panel adresi
      page_location: (yerelUygulama ? PANEL_KOK : window.location.origin) + yol,
      page_title: (to && to.meta && to.meta.title) || document.title || '',
    });
  } catch (e) { /* yok say */ }
}

export function olay(ad, params) {
  if (!AKTIF || !ad) return;
  yukle();
  try { gtag('event', ad, params || {}); } catch (e) { /* yok say */ }
}

export function kullaniciOzellik(ozellik) {
  if (!AKTIF || !ozellik) return;
  yukle();
  const temiz = { istemci: ISTEMCI }; // set user_properties nesneyi değiştirir, istemci düşmesin
  if (ozellik.hesap_turu) temiz.hesap_turu = String(ozellik.hesap_turu).slice(0, 36);
  // GA4 kullanıcı özelliği değeri en fazla 36 karakter.
  if (ozellik.paket != null) temiz.paket = String(ozellik.paket).slice(0, 36) || 'yok';
  try { gtag('set', 'user_properties', temiz); } catch (e) { /* yok say */ }
}

// Demo sürümü ayrı istemci (HepyApp-DemoClient, demo.hepy.app); bu kod oraya taşınırsa alan adından ayrışır.
function demoMu() {
  try { return /^demo\./i.test(window.location.hostname); } catch (e) { return false; }
}

// Oturum başına bir kez (token değişince tekrar): hesap_turu + paket. Konsol yetkisi henüz
// sorulmadıysa (guard sormadan önce) bekler, bir sonraki gezinmede yeniden dener — yanlış
// "kiraci" etiketi basmamak için.
export async function kullaniciOzellikGuncelle() {
  if (!AKTIF) return;
  const token = depo.oku('token');
  if (!token || ozellikToken === token) return;
  let hesapTuru;
  if (demoMu()) hesapTuru = 'demo';
  else if (AuthService.sirketeGecAktifMi()) hesapTuru = 'saglayici'; // destek görüntülemesi (şirkete geç)
  else if (sistemKonsol.yuklendi && sistemKonsol.token === token) hesapTuru = sistemKonsol.erisim ? 'saglayici' : 'kiraci';
  else return;
  ozellikToken = token;
  let paket = '';
  if (hesapTuru !== 'saglayici') {
    try {
      const set = await getAktifLisanslar();
      paket = Array.from(set || []).filter(Boolean).sort().join(',');
    } catch (e) { paket = ''; }
  }
  kullaniciOzellik({ hesap_turu: hesapTuru, paket: paket || 'yok' });
}

export default { sayfa, olay, kullaniciOzellik, kullaniciOzellikGuncelle, aktif: AKTIF };
